import { render, staticRenderFns } from "./aprovacao.vue?vue&type=template&id=4e0897d4&scoped=true&"
import script from "./aprovacao.vue?vue&type=script&lang=js&"
export * from "./aprovacao.vue?vue&type=script&lang=js&"
import style0 from "./aprovacao.vue?vue&type=style&index=0&id=4e0897d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0897d4",
  null
  
)

export default component.exports